import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import es from 'vuetify/lib/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        primary: '#80BD28',
        recording: '#EB625E',
        secondary: '#E6E6E6',
        success: '#4CAF50',
        warning: '#FFC107',
      },
      corporate: {
        primary: '#005BAC',
        secondary: '#00AEEF',
        accent: '#F4C300',
        error: '#E94E1B',
        info: '#0072CE',
        success: '#78BE20',
        warning: '#FFB81C',
        background: '#F8F8F8',
      },
    },
  },
  lang: {
    locales: { es },
    current: 'es',
  },
  breakpoint: {
    mobileBreakpoint: 'sm',
  },
});
